// // src/HourGroupedTable.js
// import React, { useState } from "react";
// import {
//   Box,
//   Collapse,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
//   Paper,
//   Button,
// } from "@mui/material";

// const HourGroupedTable2 = ({ data }) => {
//   const [visibleHour, setVisibleHour] = useState(null);

//   const handleModuleClick = (hour) => {
//     setVisibleHour(visibleHour === hour ? null : hour);
//   };

//   const groupByHour = (data) => {
//     return data.reduce((acc, record) => {
//       const date = new Date(record.Time);
//       const hour = date.getUTCHours();
//       if (!acc[hour]) {
//         acc[hour] = [];
//       }
//       acc[hour].push(record);
//       return acc;
//     }, {});
//   };

//   const groupedData = groupByHour(data);

//   return (
//     <Box>
//       {Object.keys(groupedData).map((hour) => (
//         <Box key={hour} mb={2} component={Paper}>
//           <Button
//             fullWidth
//             variant="contained"
//             color="primary"
//             onClick={() => handleModuleClick(hour)}
//           >
//             Hour: {hour}:00 UTC
//           </Button>
//           <Collapse in={visibleHour == hour} timeout="auto" unmountOnExit>
//             <TableContainer>
//               <Table>
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Datetime</TableCell>
//                     <TableCell>Data</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {groupedData[hour].map((record, index) => (
//                     <TableRow key={index}>
//                       <TableCell>
//                         {new Date(record.Time).toLocaleString()}
//                       </TableCell>
//                       <TableCell>{record.SubReportName}</TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           </Collapse>
//         </Box>
//       ))}
//     </Box>
//   );
// };

// export default HourGroupedTable2;

// src/DateHourGroupedTable.js
// src/HourGroupedTable2.js
import React, { useState } from "react";
import {
  Box,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Button,
  Modal,
  Stack,
  IconButton,
} from "@mui/material";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { styled } from "@mui/system";
import DateFormatter from "./DateFormatter";
import ExportToExcelBTN from "./ExportToExcelBTN";

const SmallTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(1),
  fontSize: "0.875rem",
  "& p": {
    margin: 0,
  },
}));

const Time = {
  10: {
    hr: "10",
    label: "10:00 AM",
    id: 1,
  },
  11: {
    hr: "11",
    label: "11:00 AM",
    id: 1,
  },
  12: {
    hr: "12",
    label: "12:00 PM",
    id: 1,
  },
  13: {
    hr: "13",
    label: "01:00 PM",
    id: 1,
  },
  14: {
    hr: "14",
    label: "02:00 PM",
    id: 1,
  },
  15: {
    hr: "15",
    label: "03:00 PM",
    id: 1,
  },
  16: {
    hr: "16",
    label: "04:00 PM",
    id: 1,
  },
  17: {
    hr: "17",
    label: "05:00 PM",
    id: 1,
  },
  18: {
    hr: "18",
    label: "06:00 PM",
    id: 1,
  },
  19: {
    hr: "19",
    label: "07:00 PM",
    id: 1,
  },
  20: {
    hr: "20",
    label: "08:00 PM",
    id: 1,
  },
};

const HourGroupedTable2 = ({ data }) => {
  const [visibleDate, setVisibleDate] = useState(null);
  const [visibleHour, setVisibleHour] = useState(null);
  const [open, setOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [rotation, setRotation] = useState(0);

  const handleDateClick = (date) => {
    setVisibleDate(visibleDate === date ? null : date);
    setVisibleHour(null); // Reset hour visibility when changing date
  };

  const handleHourClick = (hour) => {
    setVisibleHour(visibleHour === hour ? null : hour);
  };

  const handleOpen = (imgLink) => {
    setModalImage(`https://www.apsgroupapp.com/uploads/${imgLink}`);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setRotation(0);
  };

  const rotateLeft = () => setRotation((prev) => prev - 90);
  const rotateRight = () => setRotation((prev) => prev + 90);

  const groupByDateAndHour = (data) => {
    return data.reduce((acc, record) => {
      const date = new Date(record.Time);
      const dateString = date.toISOString().split("T")[0];
      const hour = date.getUTCHours();

      if (!acc[dateString]) {
        acc[dateString] = {};
      }
      if (!acc[dateString][hour]) {
        acc[dateString][hour] = [];
      }
      acc[dateString][hour].push(record);

      return acc;
    }, {});
  };

  const groupedData = groupByDateAndHour(data);

  return (
    <Box>
      <Stack
        sx={{
          display: "flex",
          alignItems: "flex-end",
          flexDirection: "row",
          justifyContent: "space-between",
          margin: 2,
        }}
      >
        <ExportToExcelBTN data={data} />
      </Stack>
      {Object.keys(groupedData).map((date) => (
        <Box key={date} mb={2} component={Paper}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => handleDateClick(date)}
          >
            Date: {date}
          </Button>
          <Collapse in={visibleDate === date} timeout="auto" unmountOnExit>
            {Object.keys(Time).map((hour) => (
              <Box
                key={hour}
                mt={2}
                ml={2}
                component={Paper}
                sx={{
                  backgroundColor: groupedData[date][hour]
                    ? "default"
                    : "#f8d7da", // Light red background for missed hours
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  color={groupedData[date][hour] ? "secondary" : "error"}
                  onClick={
                    groupedData[date][hour] ? () => handleHourClick(hour) : null
                  }
                >
                  {groupedData[date][hour]
                    ? `${Time[hour].label} Report`
                    : `${Time[hour].label} Report - Missed`}
                </Button>
                {groupedData[date][hour] && (
                  <Collapse
                    in={visibleHour == hour}
                    timeout="auto"
                    unmountOnExit
                  >
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <SmallTableCell>Unit Code</SmallTableCell>
                            <SmallTableCell>EmpCode</SmallTableCell>
                            <SmallTableCell>Sub-Report Name</SmallTableCell>
                            <SmallTableCell>Remark</SmallTableCell>
                            <SmallTableCell>Time</SmallTableCell>
                            <SmallTableCell>Status</SmallTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {groupedData[date][hour].map((record, index) => (
                            <TableRow key={index}>
                              <SmallTableCell>{record.Unitcode}</SmallTableCell>
                              <SmallTableCell>{record.EmpCode}</SmallTableCell>
                              <SmallTableCell>
                                {record.SubReportName}
                              </SmallTableCell>
                              <SmallTableCell>{record.Remark}</SmallTableCell>
                              <SmallTableCell>
                                <DateFormatter date={record.Time} />
                              </SmallTableCell>
                              <SmallTableCell>
                                {record.ImgName === "NULL" ? (
                                  "NOT DONE"
                                ) : (
                                  <IconButton
                                    sx={{ padding: 0 }}
                                    onClick={() => handleOpen(record.ImgName)}
                                  >
                                    <VisibilityIcon fontSize="small" />
                                  </IconButton>
                                )}
                              </SmallTableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Collapse>
                )}
              </Box>
            ))}
          </Collapse>
        </Box>
      ))}

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <img
            src={modalImage}
            alt="Modal Display"
            style={{ maxWidth: "100%", transform: `rotate(${rotation}deg)` }}
          />
          <Stack sx={{ display: "flex", flexDirection: "row" }}>
            <IconButton onClick={rotateLeft}>
              <RotateLeftIcon />
            </IconButton>
            <IconButton onClick={rotateRight}>
              <RotateRightIcon />
            </IconButton>
          </Stack>
        </Box>
      </Modal>
    </Box>
  );
};

export default HourGroupedTable2;

{
  /* <Box key={hour} mt={2} ml={2} component={Paper}>
<Button
  fullWidth
  variant="contained"
  color="primary"
  onClick={() => handleHourClick(hour)}
>
  Missed
</Button>
</Box> */
}
